
// Vue
import {Options, Vue} from "vue-class-component";

@Options({})
export default class AdministratorHealthRecordsNavigationVue extends Vue {}
